import script from "./PetDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PetDetails.vue?vue&type=script&setup=true&lang=js"

import "./PetDetails.vue?vue&type=style&index=0&id=dd7594d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd7594d0"]])

export default __exports__